const COOKIE_KEY = '__hu_show_cookie_info__';
import { isNice } from 'config/config';
import { isUserBot } from 'src/utils/seo';
import { getLocalStorageItem, setLocalStorageItem } from './localStorage';

export const isVisible = () => {
  if (isNice || isUserBot) return false;
  return !getLocalStorageItem(COOKIE_KEY);
};

export const hide = () => {
  setLocalStorageItem(COOKIE_KEY, true);
};



// WEBPACK FOOTER //
// ./src/utils/cookieBanner.js